import { isDefined } from "@clipboard-health/util-ts";
import { type Agent } from "@src/appV2/Agents";
import { RootPaths } from "@src/appV2/App/paths";
import { BannerLink } from "@src/appV2/lib/Alert";

import {
  useWorkerAvailabilityVersion,
  WorkerAvailabilityVersion,
} from "../../hooks/useWorkerAvailabilityVersion";
import { WORKER_AVAILABILITIES_PATH } from "../../paths";
import { useGetWorkerAvailabilityBannerV1Content } from "./useGetWorkerAvailabilityBannerV1Content";
import { useGetWorkerAvailabilityBannerV2Content } from "./useGetWorkerAvailabilityBannerV2Content";

interface WorkerAvailabilityBannersProps {
  agent: Agent;
}

export function WorkerAvailabilityBanners(props: WorkerAvailabilityBannersProps) {
  const { agent } = props;

  const workerAvailabilityVersion = useWorkerAvailabilityVersion();

  const { title: titleForV1Banner, description: descriptionForV1Banner } =
    useGetWorkerAvailabilityBannerV1Content({
      selectedDate: new Date(),
      timezone: agent.tmz,
    });

  const { title: titleForV2Banner, description: descriptionForV2Banner } =
    useGetWorkerAvailabilityBannerV2Content();

  function getBannerContent() {
    if (workerAvailabilityVersion === WorkerAvailabilityVersion.V1) {
      return {
        title: titleForV1Banner,
        description: descriptionForV1Banner,
      };
    }

    if (workerAvailabilityVersion === WorkerAvailabilityVersion.V2) {
      return {
        title: titleForV2Banner,
        description: descriptionForV2Banner,
      };
    }

    return null;
  }

  const bannerContent = getBannerContent();

  if (!isDefined(bannerContent)) {
    return null;
  }

  return (
    <BannerLink
      title={bannerContent.title}
      to={`${RootPaths.APP_V2_HOME}/${WORKER_AVAILABILITIES_PATH}`}
      severity="info"
    >
      {bannerContent.description}
    </BannerLink>
  );
}
